import { PositionKind } from "../position/types/position-kind";
import {
  PriceUsed,
  PricesUsed,
  pricesUsedOfKind,
} from "../position/types/price-used";
import { ServiceVariation } from "../servicevariation/types/service-variation";

/**
 * omniPricesUsed returns the prices an omni position may show: any, the
 * final price by default, see `omniPricesUsed`,
 * backend/core/omni/domain/servicekindrules/omni_positions.go.
 */
export function omniPricesUsed(
  kind: PositionKind,
  serviceVariation: ServiceVariation,
): PricesUsed {
  return pricesUsedOfKind(kind, serviceVariation, () => ({
    allowed: [
      PriceUsed.UnitPrice,
      PriceUsed.FinalPrice,
      PriceUsed.SubscriptionPrice,
    ],
    byDefault: PriceUsed.FinalPrice,
  }));
}
